<template>
  <div class="myTable">
    <div class="searchNav1" >
      <el-button class="newAdd" type="primary" @click="dialogVisible = true" icon="el-icon-plus" v-if="$can('auth-user:add')">新增账号</el-button>
      <span><span class="searchNameStyle">账号 ：</span><el-input style="width: 15%;" v-model="searchInfo.account" clearable placeholder="请输入"></el-input></span>
      <span><span class="searchNameStyle">角色：</span>
                <el-select v-model="searchInfo.role" clearable  @change="search" placeholder="请选择">
                    <el-option
                            v-for="(item, i) in roleList"
                            :key="i"
                            :label="item.role"
                            :value="item.id">
                    </el-option>
                </el-select>
            </span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName">
          <el-table-column
                  type="index"
                  width="50">
          </el-table-column>
        <el-table-column prop="account" label="账号" ></el-table-column>
        <el-table-column prop="roleList[0].role" label="角色"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="updateTime"  label="修改时间"></el-table-column>
        <el-table-column prop="enabled" label="状态">
          <template slot-scope="scope">
            {{ scope.row.enabled | showState1 }}
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('auth-user:edit')"   @click="edit(scope.row)">角色修改</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:disable')" @click="confirmChangeState(scope.row)">{{scope.row.enabled |showState }}</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:resetPassword')"@click="confirmResetPassword(scope.row)">重置密码</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="账号：">
                      <el-input v-model="addInfo.account" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="角色：">
                      <el-select v-model="addInfo.roleId" clearable placeholder="请选择">
                        <el-option
                                v-for="(item, i) in roleList"
                                :key="i"
                                :label="item.role"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
<!--                <el-row :gutter="20" v-if="editStatus">-->
<!--                  <el-col :span="12">-->
<!--                    <el-form-item label="默认新增密码：">-->
<!--                      12345678-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="12">-->
<!--                  </el-col>-->
<!--                </el-row>-->
              </el-form>

        <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
    </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
    import {axios} from "../../config/axios";
    export default {
        name: "white-list",
        data () {
            return {
                dialogTitle:'新增用户',
                total:1,
                tableData: [],
                loading: false,
                dialogVisible: false,
                currentPage:1,
                roleList:'',
                addInfo:{
                    account:'',
                    roleId:'',
                    companyId:'',
                },
                searchInfo:{
                  account:'',
                  role:'',
                  pageNumber:1,
                  pageSize:50,
                },
            }
        },
        created: function () {
            this.pageInfo();
            this.getAllRole();
        },
        watch: {
          'searchInfo.account'(newVal,oldVal){
            if ("" == newVal){
              this.pageInfo();
            }
          },
        },
        methods:{
            search(){
                this.pageInfo();
            },
      //改为全局方法
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val ;
                this.pageInfo();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            validate(){
                let flag = true;
                let msg  = "";
                if (this.addInfo.account.length < 3){
                    flag = false;
                    msg = " 账号长度至少 3 位 "
                }else if(this.addInfo.role === ""){
                    flag = false;
                    msg = " 角色不能为空 "
                }
                return {code:flag,msg:msg}
            },
            save(){
                let validateObj = this.validate();
                if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
                    if (validateObj.code){
                        axios.post('/user',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.clearObj(this.addInfo); // 清空新增数据
                            this.pageInfo();
                        }).catch(err => {
                            console.log(err);
                        });
                    }else{
                        this.msg(validateObj.msg);
                    }
                }else{  // 编辑
                    if (validateObj.code){
                        // 当前系列 是开启的
                        axios.put('/admin-user/info',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.pageInfo();
                            this.clearObj(this.addInfo); // 清空新增数据

                            this.dialogTitle="新增用户";
                        }).catch(err => {
                            console.log(err);
                        });
                    }else{
                        this.msg(validateObj.msg);
                    }
                }
            },
            remove(id){
                axios.delete('/user',{data: {id:id}}).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.pageInfo();
                })
            },
            confirmRemove(id){
                this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.remove(id);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleClose(done) {
                this.clearObj(this.addInfo); // 清空新增数据
                done();
            },
            edit(obj){
                this.dialogTitle = "用户编辑";
                this.addInfo.id = obj.id;
                this.addInfo.account = obj.account;
                this.addInfo.roleId = obj.roleList[0].id;
                this.dialogVisible = true;
            },
            confirmChangeState(obj){
                let operation = obj.enabled?"禁用":"开启";
                this.$confirm('确定要'+operation+obj.account+', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.changeState(obj.id);
                    this.$message({
                        type: 'success',
                        message: operation+'成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'+operation
                    });
                });
            },
            changeState(id){
                axios.put("/admin-user/disable",{id:id}).then(res => {
                    if (res.code !== 200){
                        console.log(res);
                    }
                    this.pageInfo();
                }).catch(err =>{
                    console.log(err);
                })
            },
          confirmResetPassword(obj){
            this.$confirm('确定要重置员工的密码，重置后密码：12345678 , 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.resetPassword(obj.id);
              this.$message({
                type: 'success',
                message: '重置密码成功!'
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消重置密码'
              });
            });
          },
            resetPassword(id){
                axios.put("/admin-user/reset",{id:id}).then(res => {
                    if (res.code !== 200){
                        console.log(res);
                    }
                    this.pageInfo();
                }).catch(err =>{
                    console.log(err);
                })
            },
            pageInfo(){
                if (this.loading)  return; // 防止重复提交
                this.loading=true;
                axios.get('/user',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading=false;
                });
            },
            getAllRole(){
                axios.get('/role-all',{
                    params: {}
                }).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.roleList = result.data;
                }).catch(err => {
                    console.log(err);
                });
            },
        },filters: {
            showSite(val){
              if (val){
                return "在职";
              }
              return "离职"
            },
            showState(val){
              if (val){
                return "禁用";
              }
              return "可用"
            },
        showState1(val){
                if (val){
                    return "可用";
                }
                return "禁用"
            }
        }
    }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
        margin-right: 15px;
        width: 200px;
    }
  }
</style>
